<template>
    <footer class="footer">
        <div class="container">
            <div class="record-number">Copyringht @ 2017-2024 All Rights Reserved. 深圳市布雷斯塔科技有限公司  <a target="_blank" style="color:#aeaeae" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2024264095号 </a></div>
        </div>
    </footer>
</template>
<script>
export default {
    mixins: [],
    name: "footerPage",
    components: {},
    data() {
        return {

        };
    },
    created() {},
    lang() {
        return this.$store.state.language;
    },
    async beforeMount() {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.footer {
    background-color: #000;
    color: #ecf0f1;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
}

.footer .record-number a {
    color: #1abc9c;
    text-decoration: none;
    transition: color 0.3s;
}
.footer .record-number a:hover {
    color: #16a085;
}
@media (max-width: 600px) {
    .footer {
        padding: 15px 0;
    }
}
</style>
